import React, { useState, useEffect } from "react";

import { useGlobalState } from "../../services/hostelConst";
import {
  getRolesList,
  updateRoleStatus,
  deleteRole,
} from "../../services/Users-services";
import { getMethods } from "../../services/utilityFunctions";
import MasterTable from "../../views/dashboard/widget/MasterTabel";
import AddRoleForm from "../../components/FormComponents/AddRole.js";
const RoleTable = () => {
  const [isInitialized, setIsInitialized] = useState(false);
  const {
    _advanceFilterList,
    updateAdvanceFilterList,
    resetAdvanceFilterData,
  } = useGlobalState();
  useEffect(() => {
    resetAdvanceFilterData();
    updateAdvanceFilterList((prev) => {
      return {
        ...prev,
        date: true,
        status: true,
        region: true,
        site: true,
        department: true,
      };
    });
    setIsInitialized(true);
    return () => {};
  }, []);
  return (
    <MasterTable
      tab1={"User Management"}
      tab2={"Roles"}
      getTableData={getRolesList}
      actions={{
        status: true,
        edit: true,
        delete: true,
      }}
      AddForm={AddRoleForm}
      deleteRow={deleteRole}
      updateStatus={updateRoleStatus}
    />
  );
};

export default RoleTable;
